import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogContent, DialogTitle, Icon } from "@mui/material";
import { PaperArrastavel } from "../../../dialog-arrastavel/PaperArrastavel";
import { IColuna } from "app/types/IColuna";
import clsx from "clsx";
import React, { useState } from "react";
const estilosGridItens =
  require("../../../itens-orcamento/grid-itens/grid-itens.module.scss").default;
const estilosTableHead =
  require("../../../itens-orcamento/grid-itens/head/tableHead.module.scss").default;

export type AcoesHeadPesquisaPreVendaProps = {
  onAlterarFonte?: (tamanho: number) => void;
  colunas: IColuna[];
  onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
  tamanhoFonte: number;
  exibirIconesAumentarDiminuirFonte?: boolean;
  permitirEngrenagemGrid: boolean
  larguraLinha?: number;
};

// Mapa fixo — escopo de módulo, não recriado a cada render.
const _MAPA_COLUNAS_PRE_VENDA: Record<string, string> = {
  Id: "Nº Pré-venda",
  Descricao: "Descrição",
  DataCriacao: "Data/Hora",
  CodigoVendedor: "Vendedor",
  ItensPreVenda: "Quantidade Itens",
};

const traduzirNomeColuna = (nomeColuna: string) =>
  nomeColuna in _MAPA_COLUNAS_PRE_VENDA ? _MAPA_COLUNAS_PRE_VENDA[nomeColuna] : nomeColuna;

export const AcoesHeadPesquisaPreVenda = React.memo((
  props: AcoesHeadPesquisaPreVendaProps
) => {
  const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false);
  const [mostrarBotoes, setMostrarBotoes] = useState(false);

  // Construído só quando o diálogo está aberto — evita montar a lista de colunas a cada render.
  const selecaoDeColunasDialog = exibirSelecaoColunas && (
    <Dialog
      open={exibirSelecaoColunas}
      onClose={() => setExibirSelecaoDeColunas(false)}
      id="TableHeadPesquisaPreVendas_DialogSelecaoColunas"
      PaperComponent={PaperArrastavel}
    >
      <DialogTitle>Selecionar colunas para exibição</DialogTitle>
      <DialogContent>
        <div
          id="TableHeadPesquisaPreVendas_ContainerSelecaoColunas"
          className="_grid _grid-cols-1 _grid-flow-row"
        >
          <div
            id="TableHeadPesquisaPreVendas_LinhaSelecionarTodas"
            className="_flex _flex-row _justify-start _max-w-xs _items-end"
          >
            <div id="TableHeadPesquisaPreVendas_CheckboxTodasWrapper" className="_mr-4">
              <input
                id="TableHeadPesquisaPreVendas_SelecionarTodasColunas"
                type="checkbox"
                checked={props.colunas.every((c) => c.Selecionada == true)}
                onChange={(e) =>
                  props.onToggleSelecionarTodasColunas(e.target.checked)
                }
              />
            </div>

            <b>Todas</b>
          </div>

          {props.colunas.map((coluna) => (
            <div
              id={`TableHeadPesquisaPreVendas_LinhaColuna_${coluna.Nome}`}
              className="_flex _flex-row _justify-start _max-w-xs _items-end"
              key={coluna.Nome}
            >
              <div id={`TableHeadPesquisaPreVendas_CheckboxColunaWrapper_${coluna.Nome}`} className="_mr-4">
                <input
                  id={`TableHeadPesquisaPreVendas_Coluna_${coluna.Nome}`}
                  type="checkbox"
                  checked={coluna.Selecionada ?? false}
                  onChange={() =>
                    props.onToggleColunaSelecionada(
                      coluna.Nome,
                      !coluna.Selecionada
                    )
                  }
                />
              </div>

              {traduzirNomeColuna(coluna.Nome)}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );

  const iconeExibirEsconderBotoes = (
    <button
      id="TableHeadPesquisaPreVendas_table-headgrid-itensarrow"
      className="no-global-button"
      style={{ marginLeft: "14px", height: "20px" }}
      onClick={() => setMostrarBotoes(!mostrarBotoes)}
    >
      <Icon id="TableHeadPesquisaPreVendas_table-headgrid-itensarrowIcone">
        {mostrarBotoes ? "arrow_drop_down" : "arrow_drop_up"}
      </Icon>
    </button>
  );

  const botoes = mostrarBotoes && (
    <div
      id="TableHeadPesquisaPreVendas_Botoes"
      style={{
        width:
          props.larguraLinha != undefined
            ? `${props.larguraLinha}px`
            : undefined,
      }}
      className={clsx(["_flex _flex-row _gap-x-2", estilosTableHead.acoesHead])}
    >
       {props.permitirEngrenagemGrid &&  <FontAwesomeIcon
        id="TableHeadPesquisaPreVendas_BotaoEngrenagem"
        icon={faGear}
        className="_text-2xl _cursor-pointer"
        onClick={() => setExibirSelecaoDeColunas(true)}
        />
        }

      {(props.exibirIconesAumentarDiminuirFonte ?? true) && (
        <>
          <button
            id="TableHeadPesquisaPreVendas_BotaoAumentarFonte"
            className={clsx(
              "no-global-button",
              estilosGridItens.botaoAumentarDiminuirFonte
            )}
            onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
            disabled={props.tamanhoFonte >= 26}
          >
            A+
          </button>
          <button
            id="TableHeadPesquisaPreVendas_BotaoDiminuirFonte"
            className={clsx(
              "no-global-button",
              estilosGridItens.botaoAumentarDiminuirFonte
            )}
            onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
            disabled={props.tamanhoFonte <= 8}
          >
            A-
          </button>
        </>
      )}
    </div>
  );

  return (
    <>
      <div
        id="TableHeadPesquisaPreVendas_ContainerAcoes"
        style={{ marginBottom: mostrarBotoes ? "5px" : 0 }}
      >
        {iconeExibirEsconderBotoes}
        {botoes}
      </div>

      {selecaoDeColunasDialog}
    </>
  );
});
